export default {
  "content": "<path d=\"M15.707 21.207c-.98.98-2.384 1.418-3.707 1.418s-2.727-.438-3.707-1.418l1.414-1.414c.52.52 1.366.832 2.293.832s1.773-.312 2.293-.832l1.414 1.414z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2a6.42 6.42 0 016.274 5.066l2.203 10.223A1 1 0 0119.5 18.5h-15a1.001 1.001 0 01-.978-1.21L5.726 7.065A6.419 6.419 0 0112 2zm0 2a4.419 4.419 0 00-4.32 3.487L5.739 16.5h12.524l-1.943-9.013A4.419 4.419 0 0012 4z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};